import Header from "../../../components/Header";
import Aside from "../../../components/Aside";
import Footer from "../../../components/Footer";
import { useTranslation } from "react-i18next";
import { useEffect, useMemo, useState } from "react";
import SideBar from "./SideBar";
import AgentChatView from "./AgentChatView";
import GreetingPage from "../GreetingPage";
import { FollowUpAgentsContext } from "../../../context/FollowUpAgentsContext";
import ChatToAgent from "./ChatToAgent";
import { FollowUpService } from "../../../services/FollowUpService";
import { useCurrentAccount } from "../../../hooks/useCurrentAccount";
import { NumberUtil } from "../../../utils/number";
import useRequest from "../../../hooks/useRequest";
import LoaderSmall from "../../../components/LoaderSmall";
export default function FollowUpAgentsPage() {

  const { t } = useTranslation();
  const { account } = useCurrentAccount();
  const {call, isRequesting} = useRequest();
  const [agentSelected, setAgentSelected] = useState(null);
  const [info, setInfo] = useState(undefined);

  const getCards = async () => {
    const { data } = await call(() => FollowUpService.getAgentCard(account.id));
    setInfo(data)
  }

  useEffect(() => {
    getCards();
  }, [])
  const heightRequesting = useMemo(()=> {return isRequesting ? 'h-110':''},[isRequesting]);
  return (
    <>
      <Header />
      <Aside />
      <main id="content" role="main" className="main">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-sm mb-2 mb-sm-0">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb breadcrumb-no-gutter">
                    <li className="breadcrumb-item">
                      <span className="breadcrumb-link">{t('reports.operation-title')}</span>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">{t('follow-up.header.follow-up-title')}</li>
                  </ol>
                </nav>
                <h1 className="page-header-title text-white-dark">
                  <i className="bi-chat-left-dots-fill text-primary "></i> {t('follow-up.header.follow-up-title')} - {t('follow-up.header.agents-title')}
                </h1>
              </div>
              {/* <div className="col-sm-auto">
                <a className="btn btn-primary btn-sm" data-bs-toggle="modal" onClick={downloadReports}>
                  <i className="bi-cloud-download-fill me-1"></i> Descargar tickets
                </a>
              </div> */}
            </div>
          </div>
          <div className="mb-3 mb-lg-5">
            <div className={`row relative ${heightRequesting}`}>
              {
                isRequesting ? <LoaderSmall/> :
              <>
              <div className="col-md-4">
                <div className="card card-sm">
                  <div className="card-body">
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <h6 className="card-subtitle mb-3">{t('follow-up.cards.connected-agents')}</h6>
                        <div className="">
                          <h1 className="card-title">{NumberUtil.format(info?.ac)}</h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="card card-sm">
                  <div className="card-body">
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <h6 className="card-subtitle mb-3">{t('follow-up.cards.unassigned-agents')}</h6>
                        <div className="">
                          <h1 className="card-title">{NumberUtil.format(info?.asa)}</h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="card card-sm">
                  <div className="card-body">
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <h6 className="card-subtitle mb-3">{t('follow-up.cards.licenses-available')}</h6>
                        <div className="">
                          <h1 className="card-title">{NumberUtil.format(info?.ld)}</h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </>
              }
            </div>
            <div className='row mt-md-3 p-2'>
              <FollowUpAgentsContext.Provider value={{ agentSelected, setAgentSelected }}>

                <SideBar />
                {agentSelected ? (
                  <div className='col row'>
                    <AgentChatView />
                    {/* <ChatToAgent /> */}
                  </div>
                ) : (
                  <GreetingPage />
                )}

              </FollowUpAgentsContext.Provider>

            </div>
          </div>
        </div>
        <Footer />
      </main>
    </>
  );
}
